export default (querySelector, extraOffset = 0, scrollElement = window) => {
    if (!querySelector) {
        return;
    }

    const element = querySelector instanceof Element ? querySelector : document.querySelector(querySelector);
    if (!element) {
        return;
    }

    const boundingClientRect = element.getBoundingClientRect();

    const stageBar = document.querySelector('#stageBar');
    const toolBar = document.querySelector('#toolBar');

    let offsetTop = boundingClientRect.top + window.scrollY;

    if (stageBar) {
        offsetTop -= stageBar.clientHeight;
    }

    if (toolBar) {
        offsetTop -= toolBar.clientHeight;
    }
    offsetTop -= 20;
    offsetTop -= extraOffset


    if(scrollElement !== window) {
        scrollElement = document.querySelector(scrollElement)
    }

    scrollElement.scrollTo({behavior: 'smooth', top: offsetTop});
}
